// @ts-nocheck
import * as Types from '../generated/graphqlTypes';

import { gql } from '@apollo/client';
export type TradePartnerFragment = { __typename?: 'TradePartner', id: string, name: string };

export type ProjectStageDetailFragment = { __typename?: 'ProjectStage', id: string, hasSignedContract: boolean, stage: { __typename?: 'StageDetail', code: Types.Stage, name: string, sortOrder: number }, status: { __typename?: 'ProjectStageStatusDetail', name: string, code: Types.ProjectStageStatus } };

export type HistoryFeedInfoFragment = { __typename?: 'History', avatar: string, title: string, subtitle?: string | null | undefined, recordedAt: Types.Scalars['DateTime']['input'], userName?: string | null | undefined };

export type PotentialOperationDetailsFragment = { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> };

export type CostCodeFragment = { __typename?: 'CostCode', id: string, number: string, name: string, displayName: string };

export type CostDivisionFragment = { __typename?: 'CostDivision', id: string, number: string, name: string, displayName: string };

export type ChangeEventTypeFragment = { __typename?: 'ChangeEventTypeDetail', code: Types.ChangeEventType, name: string };

export type TradePartnerContactFragment = { __typename?: 'TradePartnerContact', id: string, name: string, email?: string | null | undefined, officePhone?: string | null | undefined, mobilePhone?: string | null | undefined, address?: { __typename?: 'Address', id: string, street1: string, street2?: string | null | undefined, postalCode: string, city: string, state: string } | null | undefined };

export const TradePartnerFragmentDoc = gql`
    fragment TradePartner on TradePartner {
  id
  name
}
    `;
export const ProjectStageDetailFragmentDoc = gql`
    fragment ProjectStageDetail on ProjectStage {
  id
  hasSignedContract
  stage {
    code
    name
    sortOrder
  }
  status {
    name
    code
  }
}
    `;
export const HistoryFeedInfoFragmentDoc = gql`
    fragment HistoryFeedInfo on History {
  avatar
  title
  subtitle
  recordedAt
  userName
}
    `;
export const PotentialOperationDetailsFragmentDoc = gql`
    fragment PotentialOperationDetails on PotentialOperation2 {
  allowed
  disabledReasons {
    message
  }
}
    `;
export const CostCodeFragmentDoc = gql`
    fragment CostCode on CostCode {
  id
  number
  name
  displayName
}
    `;
export const CostDivisionFragmentDoc = gql`
    fragment CostDivision on CostDivision {
  id
  number
  name
  displayName
}
    `;
export const ChangeEventTypeFragmentDoc = gql`
    fragment ChangeEventType on ChangeEventTypeDetail {
  code
  name
}
    `;
export const TradePartnerContactFragmentDoc = gql`
    fragment TradePartnerContact on TradePartnerContact {
  id
  name
  email
  address {
    id
    street1
    street2
    postalCode
    city
    state
  }
  officePhone
  mobilePhone
}
    `;